import {
    Box, Divider, Drawer, Fab,
    List,
    ListItem,
    ListItemButton, ListItemIcon,
    ListItemText, styled
} from "@mui/material";
import brandLogo from "../../../resources/images/logo.png";
import {useState} from "react";
import MenuIcon from '@mui/icons-material/Menu';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import CategoryIcon from '@mui/icons-material/Category';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import {NavLink} from "react-router-dom";
import {useAuth} from "../../../store/AuthProvider";
import CONFIG from "../../../config/_config";

const pages = [
    {
        title: 'Home',
        link: '/admin/',
        icon: <HomeIcon />
    },
    {
        title: 'Categorie',
        link: '/admin/categorie',
        icon: <CategoryIcon />
    }, {
        title: 'Prodotti',
        link: '/admin/prodotti',
        icon: <LocalPizzaIcon />
    }, {
        title: 'Ordina Menu',
        link: '/admin/ordina-menu',
        icon: <LowPriorityIcon />
    }

];

const Navigation = () => {
    const [mobileMenuState, setMobileMenuState] = useState(false);
    const auth = useAuth();


    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setMobileMenuState(open);
    };

    const logoutHandler = () => {
        auth.logoutAction();
    }

    const drawerContent = () => {
        return <>
            <DrawerHeader>
                <img src={brandLogo} alt="La Bruschetta logo" style={{height: 50}} />
            </DrawerHeader>
            <Divider />
            <List>
                {pages.map((page, index) => (
                    <NavLink to={page.link} key={page.title} end={true} style={({isActive}) => ({
                        textDecoration: 'none',
                        color: isActive ? '#971916' : 'initial'
                    })}>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemIcon sx={{color: 'inherit'}}>
                                    {page.icon}
                                </ListItemIcon>
                                <ListItemText primary={page.title} />
                            </ListItemButton>
                        </ListItem>
                    </NavLink>
                ))}
            </List>
            <Divider />
            <List>
                <NavLink to='/' style={({isActive}) => ({
                    textDecoration: 'none',
                    color: isActive ? '#EE4740' : 'initial'
                })}>
                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon sx={{color: 'inherit'}}>
                                <WysiwygIcon />
                            </ListItemIcon>
                            <ListItemText primary='Sito' />
                        </ListItemButton>
                    </ListItem>
                </NavLink>
                <NavLink to='/admin/qrcode' style={({isActive}) => ({
                    textDecoration: 'none',
                    color: isActive ? '#EE4740' : 'initial'
                })}>
                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon sx={{color: 'inherit'}}>
                                <QrCode2Icon />
                            </ListItemIcon>
                            <ListItemText primary='QRCode Menu' />
                        </ListItemButton>
                    </ListItem>
                </NavLink>
                <ListItem disablePadding>
                    <ListItemButton onClick={logoutHandler}>
                        <ListItemIcon sx={{color: 'inherit'}}>
                            <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText primary='Logout' />
                    </ListItemButton>
                </ListItem>
            </List>
        </>
    }

    const mobileMenu = () => {
        return <>
            <Fab sx={{position: 'fixed', right: 0, bottom: 0, mb: 4, mr: 2}} size='medium' aria-label="Apri Menu" onClick={toggleDrawer(true)}>
                <MenuIcon />
            </Fab>
            <Drawer
                anchor="left"
                open={mobileMenuState}
                onClose={toggleDrawer(false)}
            >

                <Box
                    sx={{width:250}}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                >
                    { drawerContent() }
                </Box>
            </Drawer>
        </>
    }

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(5, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'center',

    }));

    const open = true;

    const desktopMenu = () => {
        return <>
            <Drawer
                sx={{
                    width: CONFIG.drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: CONFIG.drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                {drawerContent()}
            </Drawer>
        </>
    }

    return <>
        <Box sx={{mx: 4,flexGrow: 1, display: { xs: 'none', md: 'flex'} }}>
            {desktopMenu()}
        </Box>
        <Box sx={{mr:2, display: { xs: 'flex', md: 'none' } }}>
            {mobileMenu()}
        </Box>
    </>
}

export default Navigation;